import React from 'react';
import Spinner from './Spinner';

const MSALLoading = () => <Spinner position="absolute" />;

MSALLoading.propTypes = {};

export default MSALLoading;
